// This is your "database". Adding a new project is as simple as adding a new object to this array.
export const projects = [
  {
    id: "r0und", // This will be used in the URL
    title: "r0und",
    date: "07-23",
    description: [
      "r0und, farklı formları kullanarak tasarladığım alışılmışın dışında bir müzik çalar konspetidir. ",
    ],
    tags: ["#Blender3D", "#Rhino3D", "#AdobePhotoshop", "#QuixelMixer"],
    heroImage: "/projects/project-1/1.png",
    images: [
      "/projects/project-1/1.png",
      "/projects/project-1/2.png",
      "/projects/project-1/3.png",
      "/projects/project-1/4.png",
      "/projects/project-1/5.png",
    ],
  },
  {
    id: "tiji", // This will be used in the URL
    title: "tiji",
    date: "07-23",
    description: [
      "One of the most vivid memories that i can remember about 00's is the point and shoot cameras. Almost everybody has had one, and i'm pretty sure that mine has captured some of my best moments in my life. So much so that it inspired me to design a camera!",
      "Modelled in Rhino, rendered in Blender Cycles.",
    ],
    tags: ["#Blender3D", "#AdobePhotoshop", "#Rhino3D"],
    heroImage: "/projects/project-2/1.png",
    images: [
      "/projects/project-2/1.png",
      "/projects/project-2/2.png",
      "/projects/project-2/3.png",
      "/projects/project-2/4.png",
      "/projects/project-2/5.png",
      "/projects/project-2/6.png",
      "/projects/project-2/7.png",
      "/projects/project-2/8.png",
      "/projects/project-2/9.png",
      "/projects/project-2/10.png",
    ],
  },
  {
    id: "tactical-tea-cup",
    title: "Tactical Tea Cup",
    date: "11-23",
    description: [
      "I love herbal tea bags and fancy cups. I wanted to give this ordinary object, which has always been on my desk, a slightly sci-fi, slightly cyberpunk look, as to how it might look in the future, while preserving its functionality.",
      "Modelled in Rhino, rendered in Cycles.",
    ],
    tags: ["#Blender3D", "#Rhino3D", "#AdobePhotoshop", "#EmberGen"],
    heroImage: "/projects/project-1/1.png",
    images: [
      "/projects/project-3/1.png",
      "/projects/project-3/2.png",
      "/projects/project-3/3.png",
      "/projects/project-3/4.png",
      "/projects/project-3/5.png",
      "/projects/project-3/6.png",
      "/projects/project-3/7.png",
    ],
  },
  {
    id: "manual-pulse-generator",
    title: "Manual Pulse Generator - iHDW Handwheel",
    date: "03-24",
    description: [
      "Personal project i have been working on for a while to learn how to texture in Substance Painter.",
      "The rich and diverse texture of this handwheel, which I discovered in the workshop of my friend who works as a CNC operator, gave me this inspiration.",
    ],
    tags: ["#Blender3D", "#Rhino3D", "#AdobePhotoshop", "#Substance3DPainter"],
    heroImage: "/projects/project-1/1.jpg",
    images: [
      "/projects/project-4/1.jpg",
      "/projects/project-4/2.jpg",
      "/projects/project-4/3.jpg",
      "/projects/project-4/4.jpg",
      "/projects/project-4/5.jpg",
    ],
  },
];
